import {
  programmeAircraftQuery,
  programmeQuery,
  useUnenrolProgrammeAircraftMutation,
} from "@common/api/maintenance-programme"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { ENROLMENTS } from "../../-lib/search"

export const Route = createFileRoute(
  "/_layout/maintenance-programmes_/$programmeId/aircraft/remove/$enrolmentId",
)({
  component: UnenrolDialog,
})

function UnenrolDialog(): React.ReactElement {
  const { programmeId, enrolmentId } = Route.useParams()
  const { data: programme } = useSuspenseQuery(
    programmeQuery({ programme_id: programmeId }),
  )
  const { data: enrolments } = useQuery(
    programmeAircraftQuery({ programme_id: programmeId, ...ENROLMENTS }),
  )
  const mutation = useUnenrolProgrammeAircraftMutation()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const enrolment = enrolments?.data.find(({ id }) => id === enrolmentId)
  const label = enrolment?.aircraft?.registration_no ?? "this aircraft"
  const close = () =>
    navigate({
      to: "/maintenance-programmes/$programmeId",
      params: { programmeId },
      search: true,
    })

  const confirm = () =>
    mutation.mutate(
      { programme_id: programmeId, enrolment_id: enrolmentId },
      {
        onSuccess: () => {
          showToast(`Removed ${label}`, programme.number, "success")
          close()
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Remove ${label} from ${programme.number}?`}
      description="The aircraft stops following this program. Other programs it is enrolled in are not affected."
      action="Remove"
      pendingAction="Removing…"
      pending={mutation.isPending}
      disabled={!enrolment}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
